// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    MessageCommentAuthor,
    MessageCommentAuthorFromJSON,
    MessageCommentAuthorToJSON,
    MessageLinks,
    MessageLinksFromJSON,
    MessageLinksToJSON,
    MessagePriority,
    MessagePriorityFromJSON,
    MessagePriorityToJSON,
    MessagePurposeType,
    MessagePurposeTypeFromJSON,
    MessagePurposeTypeToJSON,
    SupportComment,
    SupportCommentFromJSON,
    SupportCommentToJSON,
    SupportTag,
    SupportTagFromJSON,
    SupportTagToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportMessage
 */
export interface SupportMessage {
    /**
     * The id of the message
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportMessage
     */
    id?: string;
    /**
     * The subject of the message
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportMessage
     */
    subject?: string;
    /**
     * The comments of the message
     * OpenAPI data type: {array}
     * @type {Array<SupportComment>}
     * @memberof SupportMessage
     */
    comments?: Array<SupportComment>;
    /**
     * The number of associated documents
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof SupportMessage
     */
    documents?: number;
    /**
     * The number of associated comments
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof SupportMessage
     */
    commentCount?: number;
    /**
     * The number of associated documents
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof SupportMessage
     */
    documentCount?: number;
    /**
     * The open/closed status of the message
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportMessage
     */
    open?: boolean;
    /**
     * The open/closed status of the message from the provider side
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportMessage
     */
    providerOpen?: boolean;
    /**
     * The read/unread status of the message
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportMessage
     */
    read?: boolean;
    /**
     * The read/undread status of the message from the provider side
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportMessage
     */
    providerRead?: boolean;
    /**
     * 
     * OpenAPI data type: {MessageCommentAuthor}
     * @type {MessageCommentAuthor}
     * @memberof SupportMessage
     */
    author?: MessageCommentAuthor;
    /**
     * 
     * OpenAPI data type: {MessageCommentAuthor}
     * @type {MessageCommentAuthor}
     * @memberof SupportMessage
     */
    lastAuthor?: MessageCommentAuthor;
    /**
     * 
     * OpenAPI data type: {MessagePurposeType}
     * @type {MessagePurposeType}
     * @memberof SupportMessage
     */
    purposeType?: MessagePurposeType;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportMessage
     */
    updated?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportTag>}
     * @memberof SupportMessage
     */
    tags?: Array<SupportTag>;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportMessage
     */
    created?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportMessage
     */
    dueDate?: string;
    /**
     * 
     * OpenAPI data type: {MessagePriority}
     * @type {MessagePriority}
     * @memberof SupportMessage
     */
    priority?: MessagePriority;
    /**
     * 
     * OpenAPI data type: {MessageLinks}
     * @type {MessageLinks}
     * @memberof SupportMessage
     */
    links?: MessageLinks;
    /**
     * 
     * OpenAPI data type: {object}
     * @type {object}
     * @memberof SupportMessage
     */
    supportMetadata?: object;
}

export function SupportMessageFromJSON(json: any): SupportMessage {
    return {
            'id': !exists(json, 'id') ? undefined : json['id'],
            'subject': !exists(json, 'subject') ? undefined : json['subject'],
            'comments': !exists(json, 'comments') ? undefined : (json['comments'] as Array<any>).map(SupportCommentFromJSON),
            'documents': !exists(json, 'documents') ? undefined : json['documents'],
            'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
            'documentCount': !exists(json, 'documentCount') ? undefined : json['documentCount'],
            'open': !exists(json, 'open') ? undefined : json['open'],
            'providerOpen': !exists(json, 'providerOpen') ? undefined : json['providerOpen'],
            'read': !exists(json, 'read') ? undefined : json['read'],
            'providerRead': !exists(json, 'providerRead') ? undefined : json['providerRead'],
            'author': !exists(json, 'author') ? undefined : MessageCommentAuthorFromJSON(json['author']),
            'lastAuthor': !exists(json, 'lastAuthor') ? undefined : MessageCommentAuthorFromJSON(json['lastAuthor']),
            'purposeType': !exists(json, 'purposeType') ? undefined : MessagePurposeTypeFromJSON(json['purposeType']),
            'updated': !exists(json, 'updated') ? undefined : json['updated'],
            'tags': !exists(json, 'tags') ? undefined : (json['tags'] as Array<any>).map(SupportTagFromJSON),
            'created': !exists(json, 'created') ? undefined : json['created'],
            'dueDate': !exists(json, 'dueDate') ? undefined : json['dueDate'],
            'priority': !exists(json, 'priority') ? undefined : MessagePriorityFromJSON(json['priority']),
            'links': !exists(json, 'links') ? undefined : MessageLinksFromJSON(json['links']),
            'supportMetadata': !exists(json, 'supportMetadata') ? undefined : json['supportMetadata'],
    };

}

export function SupportMessageToForm(value?: SupportMessage): any {
    let jsonVal = SupportMessageToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportMessageToJSON(value?: SupportMessage): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'subject': cleanupBlankValuesForBackend(value.subject),
            'comments': (value.comments === undefined || value.comments === null) ? undefined : (value.comments as Array<any>).map(SupportCommentToJSON),
            'documents': cleanupBlankValuesForBackend(value.documents),
            'commentCount': cleanupBlankValuesForBackend(value.commentCount),
            'documentCount': cleanupBlankValuesForBackend(value.documentCount),
            'open': cleanupBlankValuesForBackend(value.open),
            'providerOpen': cleanupBlankValuesForBackend(value.providerOpen),
            'read': cleanupBlankValuesForBackend(value.read),
            'providerRead': cleanupBlankValuesForBackend(value.providerRead),
            'author': MessageCommentAuthorToJSON(value.author),
            'lastAuthor': MessageCommentAuthorToJSON(value.lastAuthor),
            'purposeType': MessagePurposeTypeToJSON(value.purposeType),
            'updated': cleanupBlankValuesForBackend(value.updated),
            'tags': (value.tags === undefined || value.tags === null) ? undefined : (value.tags as Array<any>).map(SupportTagToJSON),
            'created': cleanupBlankValuesForBackend(value.created),
            'dueDate': cleanupBlankValuesForBackend(value.dueDate),
            'priority': MessagePriorityToJSON(value.priority),
            'links': MessageLinksToJSON(value.links),
            'supportMetadata': cleanupBlankValuesForBackend(value.supportMetadata),
    };
}


